export default function () {
  return [
    {name: 'Ene', monto: 45000},
    {name: 'Mar', monto: 43300},
    {name: 'Abr', monto: 43000},
    {name: 'May', monto: 30000},
    {name: 'Jun', monto: 30000},
    {name: 'Jul', monto: 20000},
    {name: 'Ago', monto: 23000},
    {name: 'Sep', monto: 19500},
    {name: 'Oct', monto: 17000},
    {name: 'Nov', monto: 17000},
    {name: 'Dic', monto: 15000},
  ]
};



// WEBPACK FOOTER //
// ./src/reducers/chart-reducers/globalPortfolioReduce.js